import ValidatorsApi from "api/ValidatorsApi";
import { IQueryOptions, QueryKey, useQueryWrapper } from "./api-hooks-common";

// eslint-disable-next-line import/prefer-default-export
export const useGetCronValidation = (expression: string, options?: IQueryOptions) =>
  useQueryWrapper(
    [QueryKey.VALIDATOR_CRON, expression],
    () => ValidatorsApi.getCronValidation(expression),
    null,
    options
  );
